import LeadgenFormLead from '@/entities/LeadgenFormLead';
import api from '@/services/Api';

// Every call answers with the lead, its history included.
export default {
  getById(id) {
    return api().get('/leadgen-form-lead/' + id)
      .then(resp => new LeadgenFormLead(resp));
  },

  updateStatus(id, status) {
    return api().put('/leadgen-form-lead/' + id + '/status', { status })
      .then(resp => new LeadgenFormLead(resp));
  },

  updateAssignee(id, userId) {
    return api().put('/leadgen-form-lead/' + id + '/assignee', { user_id: userId })
      .then(resp => new LeadgenFormLead(resp));
  },

  addComment(id, text) {
    return api().post('/leadgen-form-lead/' + id + '/comments', { text })
      .then(resp => new LeadgenFormLead(resp));
  },
};
